export default __webpack_public_path__ + "static/media/down-small-caret-green.bd821aa6.svg";